import axios from '@axios'

export default {
  getDre(params) {
    return axios.get('/financeiro/contabil/dre', { params })
  },
  getLivroRazao(params) {
    return axios.get('/financeiro/contabil/livro-razao', { params })
  },
  getRazaoAnalitico(params) {
    return axios.get('/financeiro/contabil/razao-analitico', { params })
  },
  getRazaoHierarquico(params) {
    return axios.get('/financeiro/contabil/razao-hierarquico', { params })
  },
}
